import { StorageType } from '../useListAction/types'
import type { UseListProps } from '../useList/index'
import { useList } from '../useList/index'
import { useUserTimeZone } from '../useUser/useUserTimeZone'
import type { SetOptional } from 'type-fest'
import { mailgunEventQuery } from './graphql'

export const useMailgunEventList = ({
  listActionOptions = {},
  query,
  ...props
}: SetOptional<UseListProps, 'query'>) => {
  const timeZone = useUserTimeZone()

  query = query ?? mailgunEventQuery.allConfig.query

  const finalDefaultListActions = {
    ...listActionOptions,
    storageType: listActionOptions.storageKey ? StorageType.localStorage : StorageType.none,
    timeZone,
  }

  return useList({
    query,
    ...props,
    sort: { timeStamp: -1 },
    listActionOptions: finalDefaultListActions,
  })
}
